/*
 * @Author: Chris 
 * @Date: 2022-07-29 14:37:20 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-11-08 17:58:20
 */
 
<template>
  <div class="member">
    <div class="member_top">
      <div class="top_Cname">
        <div class="Cname_name" v-if="orgdata">
          {{ orgdata.deptName }}
          <img
            v-if="orgdata.type != 'company'"
            @click="Modifyinformation"
            class="name_img"
            src="../../../assets/IMG/organization/Group.png"
            alt=""
          />
        </div>
      </div>
      <div class="organize_header">
        <!--
          登录模块升级 v2.1 §4.6：前端隐藏「邀请员工」入口。
          后端 /authUser/urlAddUser 接口保留（已在 thcl-um 中标 @Deprecated），
          待「用户管理 Agent」重做新的员工入驻流程后再恢复或替换。
          对应 prompt/登录模块升级改造方案.md §4.2 / §4.6 / §7.5 P3
        -->
        <div class="BUTTON" @click="addmember">邀请成员加入</div>
        <!-- <div class="BUTTON" @click="handleInviteUse(1)" v-if="companyType === 0">单位</div> -->
        <div class="BUTTON" @click="handleInviteSup(2)" v-if="companyType === 0">邀请监管单位</div>
        <div class="BUTTON" @click="handleInviteSup(3)" v-if="companyType === 0">邀请保险单位</div>
      </div>
    </div>
    <div class="member_bottom">
      <div class="bottom_title">
        成员列表
        <div class="title_bg"></div>
      </div>
      <div class="bottom_table">
        <div class="table_top">
          <div class="top_left">
            <div class="left_number">
              已选<span class="number">{{ chooseUser.length }}</span
              >条
            </div>
            <el-button
              style="text-decoration-line: underline"
              type="text"
              @click="adjustMembers"
            >
              调整成员部门
            </el-button>
            <el-button
              style="text-decoration-line: underline"
              type="text"
              @click="toRemove"
            >
              从部门移除
            </el-button>
          </div>
          <div class="top_right">
            <div class="bottom_leftSearch">
              <el-input
                clearable
                placeholder="请输入用户名"
                v-model="searchInput"
                @input="searchname"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
          </div>
        </div>
        <div class="table__">
          <el-table
            v-loading="tableLoading"
            ref="table"
            :header-cell-style="{ background: '#EBEBEB', color: '#333' }"
            row-key="userId"
            :data="tableData"
            style="width: 100%"
            @cell-dblclick="this.$dblClickCopy"
            :row-class-name="tableRowClassName"
            @selection-change="selectChange"
            highlight-current-row
          >
            <el-table-column
              align="center"
              type="selection"
              :reserve-selection="true"
              width="55"
            >
            </el-table-column>
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="55"
            >
            </el-table-column>
            <el-table-column prop="nickName" label="姓名">
              <template slot-scope="scope">
                <div class="name_table">
                  {{ scope.row.nickName }}
                  <div
                    class="name_table_button ZHU"
                    v-if="
                      scope.row.rolesList_CODE.indexOf('master_admin') != -1
                    "
                  >
                    主管理员
                  </div>
                  <div
                    class="name_table_button SYS"
                    v-if="scope.row.rolesList_CODE.indexOf('sys_admin') != -1"
                  >
                    系统管理员
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="username" label="账号"> </el-table-column>
            <el-table-column prop="phoneNumber" label="手机号">
            </el-table-column>
            <el-table-column prop="phoneNumber" label="成员状态">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.userStatus == 'enable'"
                  class="tableState_green"
                >
                  已启用
                </div>
                <div
                  v-if="scope.row.userStatus == 'stopUsing'"
                  class="tableState_red"
                >
                  已停用
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-link
                  class="table_link"
                  target="_blank"
                  @click="ModifymemberInformationM(scope.row)"
                >
                  <i class="el-icon-edit"></i>编辑
                </el-link>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页器 -->

          <div class="pagination">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="size"
              :current-page="current"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :total="tableDataTotal"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑部门  -->

    <EditDepartment :choosecompanyMsg="this.orgdata"></EditDepartment>

    <!-- 修改成员 -->

    <ModifyMember :chooseMemberMsg="MembertMsg"></ModifyMember>

    <!-- 调整成员部门 -->
    <ChangeDeptModal
      :visible="isShowDeptModal"
      :obj="deptObj"
      @closeModal="onCloseDeptModal"
    />
  </div>
</template>

<script>
import {
  authuserlist,
  createInvateLink,
  removeUserDept,
} from "../../../api/api";
import EditDepartment from "../components/EditDepartmentInformation";
import ModifyMember from "../components/Modifymember.vue";
import AdjustMembers from "../components/adjustMembers.vue";
import ChangeDeptModal from "../components/changeDeptModal.vue";
export default {
  components: { EditDepartment, ModifyMember, AdjustMembers, ChangeDeptModal },
  name: "member",
  props: ["orgdata"],
  data() {
    return {
      tableLoading: false,
      DepartmentInformation: this.orgdata, //当前部门信息
      MembertMsg: "", //选择的成员信息
      searchInput: "", //表格头部搜索框
      chooseUser: [], //列表选择的人
      tableData: [], //表格数据
      tableDataTotal: 0, //列表总数
      size: 10, //页面条数
      current: 1, //当前页
      // 调整部门modal
      isShowDeptModal: false,
      deptObj: {},
    };
  },
  computed: {
    companyType() {
      return this.$store.state.userInfo.companyType
    }
  },
  mounted() {},
  watch: {
    // 左侧树节点有变化时
    orgdata(newVal, oldVal) {
      this.allLoad();
    },

    /**
     * 监听vuex数据，刷新列表
     * */

    "$store.state.Refresh_UserList"(e) {
      this.getUserListMethod();
    },
  },
  methods: {
    allLoad() {
      // 需要重新请求列表、清空选择项
      this.chooseUser = [];
      this.$refs.table.clearSelection();
      // 重新请求列表
      this.current = 1;
      this.size = 10;
      this.getUserListMethod();
    },
    // 列表
    handleSizeChange(e) {
      this.size = e;
      this.getUserListMethod();
    },
    handleCurrentChange(e) {
      this.current = e;
      this.getUserListMethod();
    },
    async getUserListMethod() {
      this.tableLoading = true;
      let params = {
        userName: "",
        size: this.size,
        current: this.current,
        deptId: this.$props.orgdata.deptId,
        nickName: this.searchInput,
      };
      let res = await authuserlist(params).catch(() => {
        this.tableLoading = false;
      });
      if (res.code == 200) {
        this.tableDataTotal = res.data.total;
        this.tableData = this.Getalistofroles(res.data.content);

        this.$nextTick(() => {
          // 设置某些用户已选中
          for (let i = 0, len = this.tableData.length; i < len; i++) {
            if (this.chooseUser.includes(this.tableData[i].userId)) {
              this.$refs.table.toggleRowSelection(this.tableData[i], true);
            }
          }
        });
      }
      this.tableLoading = false;
    },
    // 搜索框
    searchname(e) {
      this.searchInput = e;
      this.getUserListMethod();
    },
    // 选择框
    selectChange(selection) {
      let arr = [];
      for (let i = 0; i < selection.length; i++) {
        arr.push(selection[i].userId);
      }
      this.chooseUser = arr;
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.chooseUser.includes(row.userId)) {
        return "chosen-row";
      }
      return "";
    },
    // 获取角色列表
    Getalistofroles(data) {
      for (let i in data) {
        let rolesList_C = [];
        let rolesList_CODE = [];
        if (data[i].roles && data[i].roles.length) {
          for (let z in data[i].roles) {
            rolesList_C.push(data[i].roles[z].roleName);
            rolesList_CODE.push(data[i].roles[z].roleCode);
          }
        } else {
          rolesList_C = [];
          rolesList_CODE = [];
        }
        data[i].rolesList_C = rolesList_C;
        data[i].rolesList_CODE = rolesList_CODE;
      }
      return data;
    },
    copyLinkM() {
      let this_ = this;
      var save = function (e) {
        e.clipboardData.setData("text/plain", this_.url);
        e.preventDefault();
      };
      document.addEventListener("copy", save);
      document.execCommand("copy");
      document.removeEventListener("copy", save);
      this.$notify.success({
        title: "成功",
        message: "生成邀请链接，已复制到剪切板！",
      });
    },
    // 调整成员部门 modal
    adjustMembers() {
      if (this.chooseUser.length) {
        this.isShowDeptModal = true;
        this.deptObj = {
          type: "multiple",
          userIds: this.chooseUser,
          deptId: this.$props.orgdata.deptId,
        };
      } else {
        this.$notify.info({
          title: "提示",
          message: "请选择成员",
        });
      }
    },
    onCloseDeptModal(e) {
      // 刷新页面
      if (e.actionType === "confirm") {
        this.allLoad();
      }
      this.isShowDeptModal = false;
    },
    // 从部门移除
    toRemove() {
      if (this.chooseUser.length) {
        this.$confirm("是否确认将选中的成员从此部门移除？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = {
            userIds: this.chooseUser,
            deptId: this.$props.orgdata.deptId,
          };
          removeUserDept(params).then((res) => {
            if (res.code == 200) {
              this.$store.commit("SET_Refresh_Organize");
              this.allLoad();
              this.$notify.success({
                title: "成功",
                message: res.msg,
              });
            }
          });
        });
      } else {
        this.$notify.info({
          title: "提示",
          message: "请选择成员",
        });
      }
    },
    // 编辑部门
    Modifyinformation() {
      this.$store.commit("SET_Drawer_Department_Edit", true);
    },
    // 编辑成员 modal
    ModifymemberInformationM(e) {
      this.MembertMsg = e;
      this.$store.commit("SET_Drawer_Member_Modify", true);
    },

    // 邀请成员加入
    async addmember() {
      let params = {
        deptId: this.$props.orgdata.deptId
      };
      let res = await createInvateLink(params);
      if (res.code == 200) {
        this.url =
          process.env.VUE_APP_WEBURL +
          "/registration/2/" +
          encodeURIComponent(res.data);
        this.copyLinkM();
      }
    },
    // 邀请使用单位
    async handleInviteUse() {
      let params = {
        maintenanceId: this.orgdata.companyId,
        companyType: 1
      };
      let res = await createInvateLink(params);
      if (res.code == 200) {
        this.url =
          process.env.VUE_APP_WEBURL +
          "/registration/1/" +
          encodeURIComponent(res.data);
        this.copyLinkM();
      }
    },
    // 邀请监管单位
    async handleInviteSup(type) {
      let params = {
        maintenanceId: this.orgdata.companyId,
        companyType: type
      };
      let res = await createInvateLink(params);
      if (res.code == 200) {
        this.url =
          process.env.VUE_APP_WEBURL +
          "/registration/1/" +
          encodeURIComponent(res.data);
        this.copyLinkM();
      }
    },
  },
};
</script>
 
<style lang="scss" scoped>
.member {
  width: 100%;
  height: calc(100vh - 146px);
  overflow-y: auto;
  padding-right: 8px;
  .member_top {
    user-select: none;
    height: 2.8125rem;
    border-bottom: 0.125rem solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .top_Cname {
      display: flex;
      align-items: center;
      .Cname_img {
        width: 3rem;
        height: 3rem;
        border-radius: 0.25rem;
        box-shadow: 0.125rem 0.125rem 0.25rem rgba(0, 0, 0, 0.16);
      }
      .Cname_name {
        font-weight: 400;
        font-size: 1rem;
        line-height: 1.5625rem;
        color: #333333;
        display: flex;
        align-items: center;
        .name_img {
          cursor: pointer;
          user-select: none;
          width: 1.5625rem;
          height: 1.5625rem;
          margin-left: 0.25rem;
        }
      }
    }
    .bottom_org {
      display: flex;
      font-weight: 400;
      font-size: 0.75rem;
      line-height: 1.25rem;
      color: #b7282d;
      margin-top: 0.875rem;
    }
    .organize_header {
      display: flex;
      .BUTTON {
        margin-left: 10px;
      }
    }
  }
  .member_bottom {
    width: 100%;
    .bottom_title {
      cursor: pointer;
      user-select: none;
      font-weight: 400;
      font-size: 1rem;
      color: #333333;
      position: relative;
      margin-top: 1rem;
      .title_bg {
        position: absolute;
        left: -0.625rem;
        bottom: 0.125rem;
        width: 6.25rem;
        height: 0.625rem;
        background: linear-gradient(
          90deg,
          rgba(183, 40, 45, 0.3) 0%,
          rgba(183, 40, 45, 0.018) 99.4%
        );
        border-radius: 0.5rem;
      }
    }
    .bottom_table {
      width: 100%;
      .table_top {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .top_left {
          display: flex;
          align-items: center;
          cursor: pointer;
          user-select: none;
          .left_number {
            font-size: 0.75rem;
            margin-right: 0.5rem;
            .number {
              font-weight: 400;
              font-size: 0.75rem;
              line-height: 1.25rem;
              color: #b7282d;
              padding: 0 0.3125rem;
            }
          }
        }
        .top_right {
          .bottom_leftSearch {
            width: 15.4375rem;
          }
        }
      }
      .table__ {
        width: 100%;
        overflow-y: auto;
        margin-top: 0.75rem;
        .name_table {
          display: flex;
          align-items: center;
          .name_table_button {
            white-space: nowrap; //文本强制不换行
            overflow: hidden; //文本溢出隐藏
            text-overflow: ellipsis;
            user-select: none;
            padding: 0.25rem 0.625rem;
            border-radius: 0.9375rem;
            margin: 0 0.25rem;
          }
          .SYS {
            background: #faf2f2;
            color: #b7282d;
          }
          .ZHU {
            background: #eff7fe;
            color: #4fb4ff;
          }
        }
        .table_link {
          margin-right: 1rem;
          .ICON_ {
            width: 0.8125rem;
            height: 0.8125rem;
          }
        }
      }
    }
  }
}
.tableState_red {
  border: 0.0625rem solid #f84638;
  border-radius: 0.9375rem;
  color: #f84638;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 1.3125rem;
}

.tableState_green {
  border: 0.0625rem solid #27c57c;
  border-radius: 0.9375rem;
  color: #27c57c;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 1.3125rem;
}
.el-button--text {
  color: #b7282d;
}
</style>